import React from "react";
import drawRings from './../helpers/drawRings';
import drawScaleScorePath from './../helpers/drawScaleScorePath';
import drawScaleScoreDots from './../helpers/drawScaleScoreDots';
import drawOuterRings from "./drawOuterRings";
import drawTextRings from "./drawTextRings";
import drawScaleTexts from "./drawScaleTexts";
import guid from "./guid";

const drawSpider = (D, colors, scales) => {
    const
        mr = D / 2 - 110, // Maximum radius
        ir = 20, // Inner radius
        offset = 10, // Offset (space between pie parts)
        x = D / 2, // Center of chart
        y = D / 2, // Center of chart
        partSizes = scales.map(scale => scale.subscales.length), // Relative pie part size
        partDepths = scales.map(scale => scale.score), // How many rings do they span (radius)
        rings = 5, // How many rings do we have
        rotation = 0, // Rotation of the whole graph in radians. Want to rotate it one quarter?: (Math.PI*2)/4;
        orr = D / 2, // Outer ring radius
        orir = (D / 2) - 30, // Outer ring inner radius
        parts = partSizes.reduce((a, b) => a + b),
        onePartSize = (Math.PI * 2) / parts,
        textIds = {
            bottomTextId: `path-${guid()}`,
            topTextId: `path-${guid()}`,
            innerBottomTextId: `path-${guid()}`,
            innerBottomTextLine2Id: `path-${guid()}`,
            innerTopTextId: `path-${guid()}`,
            innerTopTextLine2Id: `path-${guid()}`
        };
    const scaleScores = [];
    for (const scale of scales) {
        if (scale.text.bottom === false) {
            scaleScores.push(...scale.subscales.map(subscale => subscale.score).reverse());
        } else {
            scaleScores.push(...scale.subscales.map(subscale => subscale.score));
        }
    }

    return <svg
        id="personality_graph"
        viewBox="0 0 600 600"
        height="100%"
        width="100%"
    >
        <defs>
            { drawTextRings(
                x, y, orr, orir, onePartSize, rotation, textIds
            ).map(ring => ring) }
        </defs>
        { drawOuterRings(
            x, y, orr, orir, partSizes, scales, onePartSize, rotation, offset, colors
        ).map(ring => ring) }
        { drawScaleTexts(
            x, y, orir, orr, onePartSize, rotation, scales, colors, textIds
        ).map(text => text) }
        { drawRings(
            x, y, ir, mr, rings, colors
        ).map(ring => ring) }
        { drawScaleScorePath(
            x, y, onePartSize, rotation, ir, mr, rings, scaleScores
        ) }
        { drawScaleScoreDots(
            x, y, onePartSize, rotation, ir, mr, rings, scaleScores, colors
        ).map(dot => dot) }
    </svg>
};

export default drawSpider;
